import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  PROP_TYPE_PROGRAM_CONTENT,
  PROP_DEFAULT_PROGRAM_CONTENT,
  PROP_TYPE_PROGRAM_COURSE,
  PROP_DEFAULT_PROGRAM_COURSE,
} from "../../../propTypes";
import {
  getProgressColor,
  getIconBackgroundColor,
  getProgramTypeIcon,
} from "../../../functions";
import ProgramCard from "../components/Card";

import * as CONSTANTS from "../../../constants";

const StyledCourseTimeLine = styled.div`
  padding: 10px;
  overflow: hidden;

  .timeline-course {
    min-width: 700px;
    max-width: 850px;
    margin: 0px 0 0px 15px;
    min-height: 80px;
  }
`;

const StyledTimeline = styled.div`
  width: 155px;
  padding-top: 5px;
  border-left-width: 6px;
  border-left-color: ${(props) => getProgressColor(props.course)};
  padding-right: 10px;
  border-left-style: ${(props) =>
    props.course.completed === true ? "solid" : "dotted"};
  margin-right: 20px;
  display: flex;
  min-height: 70px;
`;

const TimelineCourse = (props) => {
  const { course } = props;
  const COURSE_PROGRESS_COLOR_BG = getProgressColor(course);

  return (
    <>
      <div className="timeline-course flex flex-space-b align-c">
        <StyledTimeline course={course}>
          <div style={{ position: "relative", left: "-33px" }}>
            <Icon
              color={course.completed ? CONSTANTS.COLOR_4 : CONSTANTS.COLOR_1}
              bgColor={COURSE_PROGRESS_COLOR_BG}
            >
              <strong>{props.number}</strong>
            </Icon>
          </div>
          &nbsp;&nbsp;
          <ProgramCard course={course} order={props.number} />
        </StyledTimeline>
      </div>
    </>
  );
};

TimelineCourse.propTypes = {
  course: PROP_TYPE_PROGRAM_COURSE,
  order: PropTypes.number.isRequired,
};

TimelineCourse.defaultProps = {
  course: PROP_DEFAULT_PROGRAM_COURSE,
};

const CourseTimeline = (props) => {
  const { steps, title } = props;

  return (
    <StyledCourseTimeLine className="column animated fadeInDown">
      <div className="flex flex-space-b align-c" style={{ maxWidth: "750px" }}>
        <div className="flex" style={{ padding: "0 0 0 10px" }}>
          &nbsp;
          <Icon color={CONSTANTS.COLOR_4} bgColor={CONSTANTS.COLOR_PROGRAM}>
            <span className="fa fa-graduation-cap"></span>
          </Icon>
          <h3
            style={{
              textTransform: "uppercase",
              left: "33px",
              position: "relative",
              top: "-7px",
            }}
          >
            {title}
          </h3>
        </div>
      </div>
      <br />
      {steps.map((course, index) => (
        <span custom={index} key={course.courseId}>
          <TimelineCourse number={index + 1} course={course} />
        </span>
      ))}
    </StyledCourseTimeLine>
  );
};

CourseTimeline.propTypes = {
  steps: PROP_TYPE_PROGRAM_CONTENT,
  title: PropTypes.string.isRequired,
};

CourseTimeline.defaultProps = {
  steps: PROP_DEFAULT_PROGRAM_CONTENT,
};

export default CourseTimeline;
